import gql from 'graphql-tag';

export const GET_STARTUPS = gql`
  query GetStartups {
    countries {
      code
      name
    }
    industries {
      id
      name
    }
    startups {
      id
      name
      logo_url
      industry_id
      country_code
      city
      year_founded
      description
      website
      website_active
    }
  }
`;

export const GET_STARTUP_BY_ID = gql`
  query GetStartupById($id: ID!) {
    startup(id: $id) {
      id
      name
      logo_url
      industry_id
      country_code
      city
      year_founded
      description
      website
      website_active
    }
  }
`;
